let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2mTYh")).then(() => parcelRequire('8rjeX'));